// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34Xmg","right":"styles_right__3Q8Dw"};